if (!customElements.get('masonry-flipster')) {
  class MasonryFlipster extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      try {
        $(this).flipster({
          itemContainer: 'ul',
          itemSelector: 'li',
          style: 'flat',
          start: Number(this.getAttribute('data-start')) || 'center',
          fadeIn: 400,
          loop: false,
          autoplay: false,
          spacing: -0.25,
          click: true,
          keyboard: false,
          scrollWheel: true,
          touch: false,
          nav: false,
          button: false,
        });
      } catch (error) {
        console.log(error);
      }
    }
  }

  customElements.define('masonry-flipster', MasonryFlipster);
}
